/*
 * @Author       : dengjianjun
 * @Date         : 2021-11-20 15:41:23
 * @LastEditors  : dengjianjun
 * @LastEditTime : 2021-12-06 20:04:18
 * @Description  : 公共getter
 * @FilePath     : /fe-estrain-customer/src/store/modules/common/getter.js
 */
export default {}
